import { render, staticRenderFns } from "./UserName.vue?vue&type=template&id=60fe87ae&scoped=true&"
import script from "./UserName.vue?vue&type=script&lang=js&"
export * from "./UserName.vue?vue&type=script&lang=js&"
import style0 from "./UserName.vue?vue&type=style&index=0&id=60fe87ae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fe87ae",
  null
  
)

export default component.exports